import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { EngagementService } from '../../services/engagement.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as canvasDatagrid from 'canvas-datagrid';
import { ExcelService } from 'src/app/services/excel.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { UserInputsService } from 'src/app/services/user-inputs.service';
type AOA = any[][];
import { Sharedservice } from './../../shared-components/shared.service';
import { ApplicableSourceFileTabModel } from '../../models/applicableSourceFileTab.model';
import { QuestionsModel } from '../../models/question.model';
import { QuestionOptionsModel } from '../../models/questionOptions.model';
import { MasterHelpModel } from '../../models/MasterHelp.model';
import { ErrorPopUpModel } from '../../models/errorpopup.model';
import { MasterHelpService } from '../../services/masterhelp.service';
import { severitymessage, InputCaptureComponentmessage, LanguageConstants, FunctionalityNames } from '../../shared-components/constant';
import { UserModel } from '../../models/user.model';
import { UserService } from '../../services/user.service';
import * as _moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { InfraService } from 'src/app/services/infra.service';
import { environment } from '../../../environments/environment.prod';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AuditingService } from '../../services/auditing.service';
import { AppConfigurationService } from './../../services/appConfiguration.service';
import { AppConfigurationsModel } from './../../models/appConfigurations.model';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
    selector: 'app-inputcapture',
    templateUrl: './inputcapture.component.html',
    styleUrls: ['./inputcapture.component.css']
})
export class InputCaptureComponent implements OnInit {
    canvasDataGrid: AOA = [[1, 2], [3, 4]];
    workSheets: string[] = [];
    selectedWorkSheet: string;
    myGrid: any;
    selectedCell: any;
  filebase64data: any;
  isEngagementReadOnly: boolean = false;
    applicableSourceFileTabs: ApplicableSourceFileTabModel[];
    engagementId = +this.route.snapshot.paramMap.get('id');
    accountingCalendarId: any;
    currentSourceFileTabId = 0;
    currentSourceFileTab: ApplicableSourceFileTabModel;
    scenarioId = 1;
    checkData = 0;
    loadspinner = false;
    previewloadspinner = false;
    private entity1QuestionId = 7;
    private entity2QuestionId = 8;
    private NACoverageId = 4;
    private sheetCoverageId = 3;
    private periodMonthId = 9;
    private periodYearId = 10;
    private endDateId = 33;
    private bsAmountId = 11;
    private plAmountId = 12;
    private fiscalCalendarYear = 28;
    confirmdisplay = false;
    selectedQuestion: QuestionsModel;
    accDescIdPreview: string;
    showDescIdPreview: boolean;
    isApplyToAllTabsChecked: boolean;
    prevTabIndex = 0;
    // this variable decide when we should call the getAmountQuestions()
    private IsNotAmountCall = false;
    show = false;
    sourcefilename: string;
    isProcess = false;
    private loggedInUserId: number;
    selectedIds: any[] = [];
    public descAnswer: any;
    public idAnswer: any;
    parentQuestion: QuestionsModel[];
    engagementQs: QuestionOptionsModel[];
    finalengagementQs: QuestionOptionsModel[];
    amountQs: any;
    finalamountQs: any;
    questionId = 0;
    childQsById: any;
    finalchildQsById: any;
    ChildQslist: any;
    separatorlist: any;
    isResetProcessingDisabled = true;
    onetab = false;
    validateaccountdescp: any[] = [];
    validatelastcellaccountdesc: any[] = [];
    validateaccountid: any[] = [];
    validationfields: any[] = [];
    validateSubTotal: any[] = [];
    validateBS1: any[] = [];
    validateBS2: any[] = [];
    valdiate: any[] = [];
    validatePeriodM: any[] = [];
    validatePeriodY: any[] = [];
    validateIncomeA: any[] = [];
    validateIncomeB: any[] = [];
    validateCellForPeriodMonth: any[] = [];
    validateCellForPeriodYear: any[] = [];
    selectedNonSpecialCharacter: any[] = [];
    VerifyAnswerFreeText: string;
    validateAnswerFreeText = true;
    errorModel: ErrorPopUpModel = new ErrorPopUpModel();
    existingTabName: string;
    radionumber: number = null;
    currentTabId: number;
    previousTabId: number = null;
    plStatus = false;
    isNextClicked = false;
    inValidCheckbox = '';
    private regionId: number;
    private entityQuestionIdBS = 20;
    private commaPeriodMonthId = 21;
    private commaPeriodYearId = 22;
    private commaNoPeriodMonthId = 24;
    private commaNoPeriodYearId = 25;
    private commaEndDateId = 31;
    private commaNoEndDateId = 32;
    private plbsAmountId = 26;
    private IsplbsAmountIdNo = false;
    private plOrbsAmountId = 27;
    private bsAccountId = 29;
    private plAccountId = 30;
    private dateFormate = 18;
    private firstValue = 27;
    bs_Sheet_Yes = false;
    isFiscalMonthDec = true;
    recordMessage = '';
    isSheetRowsExceeded = false;
    maxNumberOfSheetRows = 20000;
    groupsList = [];
    langCode: string;
    currLangTranslation: any;
    nextStep: any;
    previousStep: any;
    display: boolean = false;
    constructor(private infraService: InfraService, private excelService: ExcelService, private engagementService: EngagementService
      , private route: ActivatedRoute, private messageService: MessageService, private auditingService: AuditingService
        , private userInputsService: UserInputsService, private router: Router
      , private sharedService: Sharedservice, private masterHelpService: MasterHelpService,  private appConfigService: AppConfigurationService
        , private userService: UserService, private confirmationService: ConfirmationService
        , private changeDetectorRef: ChangeDetectorRef
      , private logger: NGXLogger, private translateService: TranslateService) {
      this.isEngagementReadOnly = this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");
        this.infraService.infraDetails$.subscribe((data) => {
            if (data !== undefined) {
                this.regionId = data.InfraId;
            }
        });
    }

    onTabChange(event) {
        this.isSheetRowsExceeded = false;
        this.loadspinner = true;
        this.currentSourceFileTab = this.applicableSourceFileTabs[event.index];
        this.currentSourceFileTab.IsLoaded = true;
        this.currentSourceFileTabId = this.currentSourceFileTab.Id;
        this.currentSourceFileTab.IsAppliedFromSourceTab = this.currentSourceFileTab.IsAppliedFromSourceTab === undefined ? false :
            this.currentSourceFileTab.IsAppliedFromSourceTab;
        this.currentSourceFileTab.ApplyToAllTabs = this.currentSourceFileTab.ApplyToAllTabs === undefined ? false : this.currentSourceFileTab.
            ApplyToAllTabs;
        this.isApplyToAllTabsChecked = (this.currentSourceFileTab.IsAppliedFromSourceTab === true || this.currentSourceFileTab.ApplyToAllTabs)
            ? true : false;
        // Disable the Apply to grouped tabs when the group is having single tab.
        this.onetab = this.applicableSourceFileTabs.filter(x => x.GroupName === this.currentSourceFileTab.GroupName).length === 1
            ? true : false;
        this.idAnswer = null;
        if (!this.currentSourceFileTab.Questions) {
            this.getAmountQs();
            this.getUserinputsQuestionChildQustionByIdAndParentAnswerList();
            this.getUserInputsAllQuestions('tabchange');
        } else {

            if ((this.previousTabId == null && this.currentSourceFileTab.Questions[0].AnswerFreeText != null)) {
                if (this.currentSourceFileTab.Questions[0].AnswerFreeText.filter(x => x === '10').length !== 0) {
                    this.currentSourceFileTab.Questions.map((resp) => {
                        if (resp.Id === 2) {
                            this.plStatus = false;
                            if (this.radionumber !== null) {
                                resp.AnswerFreeText = this.radionumber;
                            }
                            this.previousTabId = this.currentSourceFileTab.Id;
                        }
                    });
                }
            } else {
                this.currentSourceFileTab.Questions.map((resp) => {
                    if (resp.Id === 2) {
                        if (this.radionumber != null && this.previousTabId == null) {
                            this.plStatus = true;
                            if (this.radionumber !== null) {
                                resp.AnswerFreeText = this.radionumber;
                            }
                            this.previousTabId = this.currentSourceFileTab.Id;
                            return;
                        }
                        if ((this.radionumber != null && this.previousTabId !== this.currentSourceFileTab.Id && this.previousTabId != null)) {
                            if (this.currentSourceFileTab.IsUserInputSaved) {
                                const list = [];
                                if (this.groupsList.length > 1 || this.groupsList.length === 0) {
                                    if (this.groupsList.length === 0) {
                                        this.groupsList.push({
                                            'groupName': this.currentSourceFileTab.GroupName,
                                            'tabName': this.previousTabId, 'radioValue': this.radionumber, 'firstTabEnable': true
                                        });
                                    }
                                    if (this.groupsList.length !== 0) {
                                        this.groupsList.map(group => {
                                            list.push(group.groupName);
                                        });
                                        if (list.indexOf(this.currentSourceFileTab.GroupName) === -1) {
                                            this.groupsList.push({
                                                'groupName': this.currentSourceFileTab.GroupName,
                                                'tabName': this.currentSourceFileTab.TabName, 'radioValue': this.radionumber, 'firstTabEnable': true
                                            });
                                        }
                                    }
                                }
                            }
                            this.groupsList.filter((val, i) => {
                                if (val.groupName === this.currentSourceFileTab.GroupName) {
                                    if ((val.tabName == this.currentSourceFileTab.TabName || val.tabName == this.currentSourceFileTab.Id) && val.firstTabEnable) {
                                        this.plStatus = false;
                                    } else {
                                        this.plStatus = true;
                                    }
                                    this.radionumber = val.radioValue;

                                }
                            });
                            resp.AnswerFreeText = this.radionumber;
                        } else {
                            this.plStatus = false;
                        }
                    }
                });
            }
        }

        const gridId = 'grid' + event.index;
        const tabSize = Math.abs(this.currentSourceFileTab.Size / this.applicableSourceFileTabs.filter(x => x.SourceFileId ===
            this.currentSourceFileTab.SourceFileId).length);
        if (this.currentSourceFileTab.SheetRows > this.maxNumberOfSheetRows) {
            this.isSheetRowsExceeded = true;
            // There are more than 20000 record then show below message
            // Preview unavailable due to large number of records.Please refer to source file[s] for population of user inputs at left.
            this.recordMessage = this.currLangTranslation.step3.messages.previewSheetRowExceedCountMessage;
            this.loadspinner = false;
        } else if (tabSize > environment.maxPreviewFileSize) {
            this.isSheetRowsExceeded = true;
            this.recordMessage = this.currLangTranslation.step3.messages.previewSheetSizeExceedMessage;
            this.loadspinner = false;
        } else {
            if (document.getElementById(gridId) === null || document.getElementById(gridId).innerHTML === '') {
                setTimeout(() => {
                    this.initializeCanvasGrid(gridId);
                    this.previewTab(this.currentSourceFileTab.SourceFileId, this.currentSourceFileTab.TabName, this.currentSourceFileTab.FileName);
                }, 3000);
            } else {
                setTimeout(() => {
                    this.previewTab(this.currentSourceFileTab.SourceFileId, this.currentSourceFileTab.TabName, this.currentSourceFileTab.FileName);
                }, 2000);
            }
        }
        this.prevTabIndex = event.index;

    }

    GetQueationsByTabId(tab) {
        this.loadspinner = true;
        this.currentSourceFileTab = this.applicableSourceFileTabs[tab];
        this.currentSourceFileTab.IsLoaded = true;
        this.currentSourceFileTabId = this.currentSourceFileTab.Id;
        this.idAnswer = null;
        if (!this.currentSourceFileTab.Questions) {
            this.getAmountQs();
            this.getUserinputsQuestionChildQustionByIdAndParentAnswerList();
            this.getUserInputsAllQuestions('tabchange');
        } else {

            if ((this.previousTabId == null && this.currentSourceFileTab.Questions[0].AnswerFreeText != undefined)) {
                if (this.currentSourceFileTab.Questions[0].AnswerFreeText.filter(x => x === '10').length !== 0) {
                    this.currentSourceFileTab.Questions.map((resp) => {
                        if (resp.Id === 2) {
                            this.plStatus = false;
                            resp.AnswerFreeText = this.radionumber;
                            this.previousTabId = this.currentSourceFileTab.Id;
                        }
                    });
                }
                // return;
            } else {
                this.currentSourceFileTab.Questions.map((resp) => {
                    if (resp.Id === 2) {
                        if (this.radionumber != null && this.previousTabId == null) {
                            this.plStatus = true;
                            resp.AnswerFreeText = this.radionumber;
                            this.previousTabId = this.currentSourceFileTab.Id;
                            return;
                        }
                        if ((this.radionumber != null && this.previousTabId !== this.currentSourceFileTab.Id && this.previousTabId != null)) {
                            this.plStatus = true;
                            resp.AnswerFreeText = this.radionumber;
                        } else {
                            this.plStatus = false;
                        }
                    }
                });
            }
        }

        const gridId = 'grid' + tab;
        if (document.getElementById(gridId).innerHTML === '') {
            setTimeout(() => {
                this.initializeCanvasGrid(gridId);
                this.previewTab(this.currentSourceFileTab.SourceFileId, this.currentSourceFileTab.TabName, this.currentSourceFileTab.FileName);
            }, 3000);
        } else {
            setTimeout(() => {
                this.previewTab(this.currentSourceFileTab.SourceFileId, this.currentSourceFileTab.TabName, this.currentSourceFileTab.FileName);
            }, 2000);
        }
        this.prevTabIndex = tab;

    }

    ngOnInit() {
        this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
        this.currLangTranslation = this.translateService.translations[this.langCode];
        this.nextStep = this.currLangTranslation.actionButtons.nextStep;
        this.previousStep = this.currLangTranslation.actionButtons.previousStep;
        this.sharedService.setactiveindex(2);
        this.engagementService.getEngagement(this.engagementId)
            .subscribe((data) => {
                this.accountingCalendarId = data.AccCalendarId;
            });
        this.userInputsService.getApplicableSourceFileTabs(this.engagementId).subscribe(
            (data: ApplicableSourceFileTabModel[]) => {
                data.length > 0 && data[0]['FiscalYearEndMonth'] === 12 ? this.isFiscalMonthDec = true : this.isFiscalMonthDec = false;
                this.applicableSourceFileTabs = data;
                // this.logger.info(data);
                if (data.length === 1 || this.applicableSourceFileTabs.filter(x => x.GroupName === this.applicableSourceFileTabs[0].GroupName)
                    .length === 1) {
                    this.onetab = true;
                }

                if (data.length > 0) {
                    this.currentSourceFileTabId = data[0].Id;
                    this.currentSourceFileTab = data[0];
                    this.isProcess = data[0].IsProcessed;
                    this.currentSourceFileTab.IsLoaded = true;
                    const tabSize = Math.abs(this.currentSourceFileTab.Size / this.applicableSourceFileTabs.filter(x => x.SourceFileId ===
                        this.currentSourceFileTab.SourceFileId).length);
                    this.getAmountQs();
                    this.getUserinputsQuestionChildQustionByIdAndParentAnswerList();
                    this.getUserinputsQuestionOptions();
                    if (data.findIndex(x => x.IsProcessed === true || x.IsUserInputSaved === true) >= 0) {
                        this.checkAndGetQuestionTwoValue();
                    }

                    // if (data.length === data.filter(x => x.IsProcessed).length) {
                    if (data.filter(x => x.IsProcessed).length > 0) {
                        this.isResetProcessingDisabled = false;
                    }

                    if (this.currentSourceFileTab.SheetRows > this.maxNumberOfSheetRows) {
                        this.isSheetRowsExceeded = true;
                        // There are more than 20000 record then show below message
                        // Preview unavailable due to large number of records.Please refer to source file[s] for population of user inputs at left.
                        this.recordMessage = this.currLangTranslation.step3.messages.previewSheetRowExceedCountMessage;
                        this.loadspinner = false;
                    } else if (tabSize > environment.maxPreviewFileSize) {
                        this.isSheetRowsExceeded = true;
                        this.recordMessage = this.currLangTranslation.step3.messages.previewSheetSizeExceedMessage;
                        this.loadspinner = false;
                    } else {
                        setTimeout(() => {
                            this.initializeCanvasGrid('grid0');
                            this.previewTab(this.currentSourceFileTab.SourceFileId, this.currentSourceFileTab.TabName,
                                this.currentSourceFileTab.FileName);
                        }, 3000);
                    }
                }
                // this.changeDetectorRef.detectChanges();
            });

        this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
            this.currLangTranslation = langEvent.translations;
            this.previousStep = this.currLangTranslation.actionButtons.previousStep;
            this.nextStep = this.currLangTranslation.actionButtons.nextStep;
        });
    }

    checkAndGetQuestionTwoValue() {
        this.userInputsService.getQuestionTwoValue(this.engagementId).subscribe((data: any) => {
            // this.logger.info(data);
            if (data) {
                this.radionumber = data.AnswerFreeText;
                this.previousTabId = data.TabId;
                this.groupsList.push({
                    'groupName': this.currentSourceFileTab.GroupName,
                    'tabName': data.TabId, 'radioValue': this.radionumber, 'firstTabEnable': true
                });
            }
        });
    }

    CheckSpecialCharacter(VerifyAnswerFreeText) {

        // var specials = /[*|\"<>[\]{}`\\()';%#@&$-]/;
        const letterNumber = /^[0-9a-zA-Z]+$/;
        if (letterNumber.test(VerifyAnswerFreeText)) {
            this.validateAnswerFreeText = false;
            return;
        }

    }

    // Handel Account Description/Period Month and Year
    validateDataWithRegex(VerifyAnswerFreeText) {
        // To check whether VerifyAnswerFreeText contains any special character before split.
        const specials = /[*|\"<>[\]{}`\\()';@&$]/;
        // this.firstAccntDescript = VerifyAnswerFreeText;
        if (specials.test(VerifyAnswerFreeText)) {
            this.validateAnswerFreeText = false;
            return;
        }
        if (VerifyAnswerFreeText == null || VerifyAnswerFreeText === undefined || VerifyAnswerFreeText === '') {
            this.validateAnswerFreeText = true;
            return;
        }
        const inputValue = VerifyAnswerFreeText.split(/[.\:_]/);
        // this.firstAccntDescript = VerifyAnswerFreeText;
        // To check Aphanumeric present for single string eg: A9
        if (inputValue.length === 1) {
            const pattern = RegExp('^(?=.*[a-zA-Z])([a-zA-Z0-9]+)([0-9])$');
            if (pattern.test(VerifyAnswerFreeText)) {
                // this.firstCellSingalValue=true;
                // this.regexfirstAccountDescript =VerifyAnswerFreeText.substring(0, 1);
                // this.firstAccountNumber=parseInt(VerifyAnswerFreeText.substring(1,));
                this.validateAnswerFreeText = true;
                return;
            } else {
                this.validateAnswerFreeText = false;
                return;
            }
        } else {
            // This is for checking Double Colon
            // this.firstCellSingalValue=false;//
            const firstValue = VerifyAnswerFreeText.split(/[.\:_]/)[0];
            // var Doublecolon = inputValue.includes("");
            // if (Doublecolon == true) {
            //  this.validateAnswerFreeText = false;
            //  return;
            // }

            const Doublecolon = inputValue.indexOf('');
            if (Doublecolon !== -1) {
                this.validateAnswerFreeText = false;
                return;
            }

            // This is to check whether A9:A9 same row exist.
            const firstValueDigit = firstValue.replace(/[^0-9]/g, '');
            const patt = /[0-9]+/g;
            // this is to check last element have numeric value suppose A9:A scenario is there
            const inputValueTest = VerifyAnswerFreeText.split(/[\s,]+/);
            const checkLastElement = VerifyAnswerFreeText[VerifyAnswerFreeText.length - 1];
            const patternCheck = RegExp('^([0-9])$');
            if (patternCheck.test(checkLastElement)) {


                while (inputValue.length) {
                    const result = patt.exec(inputValue);
                    // how to check last element.
                    if (result == null) {
                        // this.validateAnswerFreeText = false;
                        break;
                    }
                    this.validateAnswerFreeText = result.every(x => x === firstValueDigit);
                }
            } else {
                this.validateAnswerFreeText = false;
                return;
            }
        }
    }
    // END

    // Handel for AccountID

    validateDataWithRegex_AccntId(VerifyAnswerFreeText) {
        // To check whether VerifyAnswerFreeText contains any special character before split.
        const specials = /[*|\"<>[\]{}`\\()':;@&$]/;
        if (specials.test(VerifyAnswerFreeText)) {
            this.validateAnswerFreeText = false;
            return;
        }

        if (VerifyAnswerFreeText == null || VerifyAnswerFreeText === undefined || VerifyAnswerFreeText === '') {
            this.validateAnswerFreeText = true;
            return;
        }
        // To check Aphanumeric present for single string eg: A9
        const pattern = RegExp('^(?=.*[a-zA-Z])([a-zA-Z0-9]+)([0-9])$');
        if (pattern.test(VerifyAnswerFreeText)) {
            this.validateAnswerFreeText = true;
            return;
        } else {
            this.validateAnswerFreeText = false;
            return;
        }
    }

    // Handel for Income and Balanace statement Amount
    validateDataWithRegex_dash(VerifyAnswerFreeText) {
        // To check whether VerifyAnswerFreeText contains any special character before split.
        const specials = /[*|\"<>[\]{}`\\()':;@&$]/;
        if (specials.test(VerifyAnswerFreeText)) {
            this.validateAnswerFreeText = false;
            return;
        }
        const inputValue = VerifyAnswerFreeText.split(/[.\+|-]/);
        // To check Aphanumeric present for single string eg: A9
        if (inputValue.length === 1) {
            const pattern = RegExp('^(?=.*[a-zA-Z])([a-zA-Z0-9]+)([0-9])$');
            if (pattern.test(VerifyAnswerFreeText)) {
                this.validateAnswerFreeText = true;
                return;
            } else {
                this.validateAnswerFreeText = false;
                return;
            }
        } else {
            // This is for checking Double Colon
            const firstValue = VerifyAnswerFreeText.split(/[.\+|-]/)[0];
            // var Doublecolon = inputValue.includes("");
            // if (Doublecolon == true) {
            //  this.validateAnswerFreeText = false;
            //  return;
            // }

            const Doublecolon = inputValue.indexOf('');
            if (Doublecolon !== -1) {
                this.validateAnswerFreeText = false;
                return;
            }
            // This is to check whether A9:A9 same row exist.
            const firstValueDigit = firstValue.replace(/[^0-9]/g, '');
            const patt = /[0-9]+/g;
            const inputValueTest = VerifyAnswerFreeText.split(/[\s,]+/);

            const checkLastElement = VerifyAnswerFreeText[VerifyAnswerFreeText.length - 1];
            const patternCheck = RegExp('^([0-9])$');
            if (patternCheck.test(checkLastElement)) {
                while (inputValue.length) {
                    const result = patt.exec(inputValue);
                    // how to check last element.
                    if (result == null) {
                        // this.validateAnswerFreeText = false;
                        break;
                    }
                    this.validateAnswerFreeText = result.every(x => x === firstValueDigit);
                }
            } else {
                this.validateAnswerFreeText = false;
                return;
            }
        }
    }

    getUserinputsQuestionOptions() {
        let results = [];
        this.userInputsService.getUserinputsQuestionOptions().subscribe
            ((data: any[]) => {
                if (data) {
                    if (this.accountingCalendarId !== 1 && this.accountingCalendarId !== 2) {
                        data.filter(val => {
                            if (val.OptionID !== 23) {
                                results.push(val);
                            }

                        });
                    } else {
                        results = data;
                    }
                }

                this.engagementQs = results;
                this.getUserInputsAllQuestions('oninit');
            });
    }

    getAmountQs() {
        // this.logger.info("--------start getAmountQs----------");
        this.userInputsService.getAmountQuestions(this.currentSourceFileTabId).subscribe
            ((data: QuestionsModel[]) => {
                this.amountQs = data;
                // this.logger.info(data);
            });

        // this.logger.info("--------End getAmountQs----------");
    }

    getUserinputsQuestionChildQustionByIdAndParentAnswerList() {
        this.userInputsService.getUserinputsQuestionChildQustionByIdAndParentAnswerList(this.currentSourceFileTabId).subscribe
            ((data: QuestionsModel[]) => {

                this.childQsById = data;
            });
    }


    private initializeCanvasGrid(gridId) {
        this.myGrid = canvasDatagrid({ parentNode: document.getElementById(gridId), data: [], editable: false });
        this.myGrid.style.height = '500px';
        this.myGrid.style.width = '100%';
        this.myGrid.addEventListener('click', (evt: any) => {
            this.clickselectionongrid(evt);
        });
    }

    private getEntityQuestionOptions(resp) {
        if (resp.QuestionType !== 0) {
            this.finalengagementQs = [];
            if (this.engagementQs) {
                this.finalengagementQs = this.engagementQs.filter(w => w.TypeID === resp.QuestionType);
                resp.QuestionOptions = this.finalengagementQs;
            }
            if ((resp.QuestionType === 5 || resp.QuestionType === 7) && resp.AnswerFreeText != undefined) {
                const ansArr = resp.AnswerFreeText.split(',');
                const stringAnsArr = [];
                ansArr.forEach(x => {
                    stringAnsArr.push(x);
                });
                resp.AnswerFreeText = stringAnsArr;
            } else
                if (resp.Id === 6 && resp.AnswerFreeText == undefined) {

                    resp.AnswerFreeText = 6;
                    this.finalchildQsById = [];
                    //// Logic for By default Below is selected and depends on below the subquestions will display
                    if (this.childQsById != undefined) {
                        this.finalchildQsById = JSON.parse(JSON.stringify(this.childQsById.filter(e => e.QuestionParent === 6 && e.QuestionParentAnswer === 6))); // New
                    }
                    this.currentSourceFileTab.Questions =
                        this.currentSourceFileTab.Questions.filter(f => f.QuestionParent !== 6);

                    let insertAt = this.currentSourceFileTab.Questions.findIndex(x => x.Id === 6);
                    this.finalchildQsById.forEach(x => {
                        insertAt++;
                        this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                    });

                    // New Code
                    this.currentSourceFileTab.Questions.map((resp1) => {
                        this.finalengagementQs = [];
                        if (this.engagementQs) {
                            this.finalengagementQs = this.engagementQs.filter(w => w.TypeID === resp1.QuestionType);
                        }
                        resp1.QuestionOptions = this.finalengagementQs;
                    });
                    this.getAmountQuestionsOnConditions();
                }

            if (resp.Id === 16 && resp.AnswerFreeText === undefined) {
                resp.AnswerFreeText = 18;
            }
        }
    }

    private getAmountQuestions(mappingtype) {
        this.finalamountQs = [];
        if (this.IsNotAmountCall === false) {
            if (mappingtype === 'pl') {
                if (this.bs_Sheet_Yes === false) {
                    this.finalamountQs = this.childQsById
                        .filter(x => x.Id === this.plOrbsAmountId);
                }
            }
            if (mappingtype === 'bs') {
                if (this.bs_Sheet_Yes === false) {
                    this.finalamountQs = this.childQsById
                        .filter(x => x.Id === this.plOrbsAmountId);
                }
            }
            if (mappingtype === 'pl,bs') {
                if (this.bs_Sheet_Yes === false) {
                    this.finalamountQs = this.childQsById
                        .filter(x => x.Id === this.plbsAmountId);
                    this.finalamountQs[0].AnswerFreeText = null;
                }
            }

            this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.plbsAmountId &&
                x.QuestionParent !== this.plbsAmountId);

            this.finalamountQs.forEach(x => {
                this.currentSourceFileTab.Questions.push(x);
            });

            this.currentSourceFileTab.Questions.map((resp) => {
                // New Code
                this.finalengagementQs = [];
                this.finalengagementQs = this.engagementQs.filter(w => w.TypeID === resp.QuestionType);

                resp.QuestionOptions = this.finalengagementQs;
            });

            // This method is for sorting the childs Qs in sequence.
            this.currentSourceFileTab.Questions.sort(function (a, b) {
                return a.Sequence - b.Sequence;
            });
        } else {
            this.IsNotAmountCall = false;
        }
    }

    private populateQuestions(question: QuestionsModel) {
        const doesQuesExist = this.currentSourceFileTab.Questions.filter(q => q.Id === question.Id)?.length > 0;
        if (!doesQuesExist) {
            this.currentSourceFileTab.Questions.push(question);
        }
    }

    private getUserInputsAllQuestions(methodCalledFrom: string) {
        this.userInputsService.getUserInputsQuestions(this.currentSourceFileTabId, this.regionId).subscribe
            ((data: QuestionsModel[]) => {
                this.parentQuestion = data;
                this.currentSourceFileTab.Questions = [];
                data.map((resp) => {
                    if (resp.Id === this.entity1QuestionId) {
                        if (this.currentSourceFileTab.EntityLevel1Id !== this.NACoverageId && this.currentSourceFileTab.EntityLevel1Id !== null) {
                            if (this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) {
                                this.populateQuestions(resp);
                                this.getEntityQuestionOptions(resp);
                            }
                        }
                    } else if (resp.Id === this.entity2QuestionId) {
                        if (this.currentSourceFileTab.EntityLevel2Id !== this.NACoverageId && this.currentSourceFileTab.EntityLevel2Id !== null) {
                            if (this.currentSourceFileTab.EntityLevel2Id === this.sheetCoverageId) {
                                this.populateQuestions(resp);
                                this.getEntityQuestionOptions(resp);
                            }
                        }
                    } else if (resp.Id === this.entityQuestionIdBS) {

                        if ((this.currentSourceFileTab.EntityLevel1Id !== this.NACoverageId && this.currentSourceFileTab.EntityLevel1Id !== null) ||
                            (this.currentSourceFileTab.EntityLevel2Id !== this.NACoverageId && this.currentSourceFileTab.EntityLevel2Id !== null)) {
                            if (((this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) || (this.currentSourceFileTab.EntityLevel2Id ===
                                this.sheetCoverageId))) {
                                if (this.currentSourceFileTab.Questions.find(x => x.Id === 7 || x.Id === 8).AnswerFreeText != null &&
                                    this.currentSourceFileTab.Questions.find(x => x.Id === 7 || x.Id === 8).AnswerFreeText.indexOf(':') > 0) {
                                    this.populateQuestions(resp);
                                    this.getEntityQuestionOptions(resp);
                                }

                            }
                        }
                    } else if (resp.Id === this.dateFormate) {
                        if (this.currentSourceFileTab.PeriodId === this.sheetCoverageId) {
                            this.populateQuestions(resp);
                            this.getEntityQuestionOptions(resp);
                        }
                    } else if (resp.Id === this.periodMonthId) {
                        const isEntityQuestionBS = this.currentSourceFileTab.Questions.find(x => x.Id === 20);
                        if (((this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) || (this.currentSourceFileTab.EntityLevel2Id ===
                            this.sheetCoverageId)) && isEntityQuestionBS === undefined) {
                            if (this.currentSourceFileTab.PeriodId === this.sheetCoverageId) {
                                if (this.currentSourceFileTab.Questions.find(x => x.Id === 7 || x.Id === 8).AnswerFreeText != null) {
                                    this.populateQuestions(resp);
                                } else {
                                    resp.AnswerFreeText = null;
                                }
                            }

                        } else if (this.currentSourceFileTab.PeriodId !== this.NACoverageId && this.currentSourceFileTab.PeriodId !== null &&
                            isEntityQuestionBS === undefined) {
                            if (this.currentSourceFileTab.PeriodId === this.sheetCoverageId) {
                                this.populateQuestions(resp);
                                this.getEntityQuestionOptions(resp);
                            }
                        }

                    } else if (resp.Id === this.periodYearId) {
                        const isEntityQuestionBS = this.currentSourceFileTab.Questions.find(x => x.Id === 20);
                        if (((this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) || (this.currentSourceFileTab.EntityLevel2Id ===
                            this.sheetCoverageId)) && isEntityQuestionBS === undefined) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId) {
                                if (this.currentSourceFileTab.Questions.find(x => x.Id === 7 || x.Id === 8).AnswerFreeText != null) {
                                    this.populateQuestions(resp);
                                } else {
                                    resp.AnswerFreeText = null;
                                }
                            }
                        } else if (this.currentSourceFileTab.PeriodIdYear !== this.NACoverageId && this.currentSourceFileTab.PeriodIdYear !== null
                            && isEntityQuestionBS === undefined) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId) {
                                this.populateQuestions(resp);
                                this.getEntityQuestionOptions(resp);
                            }
                        }
                    } else if (resp.Id === this.endDateId) {
                        const isEntityQuestionBS = this.currentSourceFileTab.Questions.find(x => x.Id === 20);
                        if (((this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) || (this.currentSourceFileTab.EntityLevel2Id ===
                            this.sheetCoverageId)) && isEntityQuestionBS === undefined) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId && (this.accountingCalendarId === 3 || this.accountingCalendarId === 4 || this.accountingCalendarId === 5)) {
                                if (this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) {
                                    if (this.currentSourceFileTab.Questions.find(x => x.Id === 7).AnswerFreeText != null) {
                                        this.populateQuestions(resp);
                                    } else {
                                        resp.AnswerFreeText = null;
                                    }
                                }
                                if (this.currentSourceFileTab.EntityLevel2Id === this.sheetCoverageId) {
                                    if (this.currentSourceFileTab.Questions.find(x => x.Id === 8).AnswerFreeText != null) {
                                        this.populateQuestions(resp);
                                    } else {
                                        resp.AnswerFreeText = null;
                                    }
                                }
                            }
                        } else if (this.currentSourceFileTab.PeriodIdYear !== this.NACoverageId && this.currentSourceFileTab.PeriodIdYear !== null
                            && isEntityQuestionBS === undefined) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId && (this.accountingCalendarId === 3 || this.accountingCalendarId === 4 || this.accountingCalendarId === 5)) {
                                this.populateQuestions(resp);
                                this.getEntityQuestionOptions(resp);
                            }
                        }
                    } else if (resp.Id === this.fiscalCalendarYear) {
                        if (this.currentSourceFileTab.PeriodIdYear !== this.NACoverageId && this.currentSourceFileTab.PeriodIdYear !== null &&
                            !this.isFiscalMonthDec && ((this.accountingCalendarId === 1 || this.accountingCalendarId === 2))) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId) {
                                this.populateQuestions(resp);
                                this.getEntityQuestionOptions(resp);
                            }
                        }
                    } else if (resp.Id === this.commaNoPeriodMonthId) {
                        const isEntityQuestionBS = this.currentSourceFileTab.Questions.find(x => x.Id === 20);
                        if (isEntityQuestionBS) {
                            if (this.currentSourceFileTab.PeriodId === this.sheetCoverageId) {
                                this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.periodMonthId);
                                this.populateQuestions(resp);
                            }
                        }
                    } else if (resp.Id === this.commaNoPeriodYearId) {
                        const isEntityQuestionBS = this.currentSourceFileTab.Questions.find(x => x.Id === 20);
                        if (isEntityQuestionBS) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId) {
                                this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.periodYearId);
                                this.populateQuestions(resp);
                            }
                        }
                    } else {
                        this.populateQuestions(resp);
                        this.getEntityQuestionOptions(resp);
                    }
                });

                if (methodCalledFrom === 'tabchange') {
                    this.currentSourceFileTab.Questions.map((resp) => {
                        const list = [];
                        const userInputList = [];
                        if (resp.Id === 2) {
                            if ((this.radionumber != null && this.previousTabId !== this.currentSourceFileTab.Id)) {
                                this.plStatus = true;
                                if (this.currentSourceFileTab.IsUserInputSaved) {
                                    this.radionumber = resp.AnswerFreeText;
                                } else {
                                    if (resp.AnswerFreeText === undefined) {
                                        resp.AnswerFreeText = this.radionumber;
                                    } else {
                                        this.radionumber = resp.AnswerFreeText;
                                    }
                                }

                                if (this.currentSourceFileTab.IsUserInputSaved) {
                                    if (this.groupsList.length !== 0 || this.groupsList.length === 0) {
                                        if (this.groupsList.length === 0) {
                                            this.groupsList.push({
                                                'groupName': this.currentSourceFileTab.GroupName,
                                                'tabName': this.previousTabId, 'radioValue': this.radionumber, 'firstTabEnable': true
                                            });
                                        }
                                        if (this.groupsList.length !== 0) {
                                            this.groupsList.map(group => {
                                                list.push(group.groupName);
                                            });
                                            if (list.indexOf(this.currentSourceFileTab.GroupName) === -1) {
                                                this.groupsList.push({
                                                    'groupName': this.currentSourceFileTab.GroupName,
                                                    'tabName': this.currentSourceFileTab.TabName, 'radioValue': this.radionumber, 'firstTabEnable': true
                                                });
                                            }

                                        }
                                    }
                                } else {
                                    if (this.groupsList.length !== 0) {
                                        this.groupsList.map(group => {
                                            userInputList.push(group.groupName);
                                        });
                                        if (userInputList.indexOf(this.currentSourceFileTab.GroupName) === -1) {
                                            this.groupsList.push({
                                                'groupName': this.currentSourceFileTab.GroupName,
                                                'tabName': this.currentSourceFileTab.TabName, 'radioValue': this.radionumber, 'firstTabEnable': true
                                            });
                                        }
                                    }
                                }
                                if (this.groupsList.length !== 0) {
                                    this.groupsList.filter((val, i) => {
                                        if (val.groupName === this.currentSourceFileTab.GroupName) {
                                            if ((val.tabName == this.currentSourceFileTab.TabName ||
                                                val.tabName == this.currentSourceFileTab.Id) && val.firstTabEnable) {
                                                this.plStatus = false;
                                            } else {
                                                this.plStatus = true;
                                            }
                                        }
                                    });
                                }
                            } else {
                                this.plStatus = false;
                            }
                        }
                    });
                } else {
                    if (!this.currentSourceFileTab.IsUserInputSaved) {
                        this.currentSourceFileTab.Questions.map((resp) => {
                            if (resp.Id === 2) {
                                if (this.radionumber === null && resp.AnswerFreeText !== undefined) {
                                    this.radionumber = resp.AnswerFreeText;
                                    this.previousTabId = resp.Id;
                                    this.groupsList.push({
                                        'groupName': this.currentSourceFileTab.GroupName,
                                        'tabName': this.currentSourceFileTab.TabName, 'radioValue': this.radionumber, 'firstTabEnable': true
                                    });
                                }
                            }
                        });
                    }
                }
            });
    }

    processFiles() {

        this.isNextClicked = true;
        this.validateUserInput();
        this.messageService.clear();
    }

    validateUserInput() {

        this.selectedIds = [];
        this.validateaccountdescp = [];
        this.validateaccountid = [];
        this.validateSubTotal = [];
        this.validateBS1 = [];
        this.validateBS2 = [];
        this.validatePeriodM = [];
        this.validatePeriodY = [];
        this.validateIncomeA = [];
        this.validateIncomeB = [];
        this.validatelastcellaccountdesc = [];
        this.validateCellForPeriodMonth = [];
        this.validateCellForPeriodYear = [];
        this.selectedNonSpecialCharacter = [];
        this.loadspinner = true;

        let tabNamelist: string[] = [];

        for (let j = 0; j < this.applicableSourceFileTabs.length; j++) {
            if (this.applicableSourceFileTabs[j].IsProcessed === false) {
                this.applicableSourceFileTabs[j].IsValidTab = '';
                if (this.applicableSourceFileTabs[j].Questions) {
                    if (this.applicableSourceFileTabs[j].Questions.filter(x => x.IsMandatory === true && (x.AnswerFreeText == null ||
                        x.AnswerFreeText === '' || x.AnswerFreeText.length === 0)).length > 0) {
                        tabNamelist[j] = this.applicableSourceFileTabs[j].TabName;
                        this.applicableSourceFileTabs[j].IsValidTab = 'invalidValue';
                    }

                } else {
                    if (!this.applicableSourceFileTabs[j].IsUserInputSaved) {
                        tabNamelist[j] = this.applicableSourceFileTabs[j].TabName;
                        this.applicableSourceFileTabs[j].IsValidTab = 'invalidValue';
                    }
                }

            }
        }
        tabNamelist = tabNamelist.filter(Boolean);
        if (tabNamelist.length > 0) {
            this.loadspinner = false;
            let message = this.currLangTranslation.step3.messages.mandatory;
            const messageList = tabNamelist.slice(0, 5).map(x => '<li>' + x + '</li>');

            if (tabNamelist.length === 1) {
                message += '.';
            } else {
                tabNamelist.length > 5 ? messageList.push('<li>... and highlighed tabs.</li>') : '';
                message += ' for below tabs. <ul>' + messageList.join('') + '</ul>';
            }

            setTimeout(() => {
                this.messageService.add({
                    key: 'tabValidation',
                    severity: severitymessage.error,
                    summary: this.currLangTranslation.severitymessage.notification,
                    detail: message,
                    sticky: true,
                    closable: true
                });
            }, 500);
            return;
        }

        for (let i = 0; i < this.applicableSourceFileTabs.length; i++) {

            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.selectedIds.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => (e.Id === 1) && e.IsMandatory === true
                        && (e.AnswerFreeText === '' || e.AnswerFreeText === null || e.AnswerFreeText.length === 0))
                });
                // return;
            }

            if (this.selectedIds.filter(x => x.Questions != 0).length !== 0) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.Mandatory, detail: InputCaptureComponentmessage.ErrorMessage.Mandatory });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.mandatory;
                return false;
            }

            // For Account Description
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {

                this.validateaccountdescp.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => (e.Id === 29 || e.Id === 30)
                        && e.IsMandatory === true && (e.AnswerFreeText === '' || e.AnswerFreeText === null || e.AnswerFreeText.length === 0 ||
                            this.validateDataWithRegex(e.AnswerFreeText)))
                });
            }

            if (this.validateaccountdescp.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText === false) {
                //  this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: severitymessage.notification,
                // detail: InputCaptureComponentmessage.ErrorMessage.SelectedField });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.selectedField;
                return false;
            }

            // Last Cell Account Description
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.validatelastcellaccountdesc.push(
                    {
                        Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id === 17 && (this.validateDataWithRegex(e.AnswerFreeText)))
                    });
            }



            if (this.validatelastcellaccountdesc.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                //  this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.SelectedField, detail: InputCaptureComponentmessage.ErrorMessage.SelectedField });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.lastCellAccountDescription;
                return false;
            }// }
            // else
            // {
            //  if (this.validatelastcellaccountdesc.filter(x => x.Questions != 0).length != 0 || this.validateAnswerFreeText != true ||
            // this.firstCellSingalValue != false) {
            //    //  this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
            // ErrorMessage.SelectedField, detail: InputCaptureComponentmessage.ErrorMessage.SelectedField });
            //    this.loadspinner = false;
            //    this.errorModel.confirmIsDisplay = true;
            //    this.errorModel.displayMessage = InputCaptureComponentmessage.ErrorMessage.LastCellAccountDescription;
            //    return false;
            //  }
            // }
            // For Account ID
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.validateaccountid.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id === 4 &&
                        (this.validateDataWithRegex(e.AnswerFreeText)))
                });
            }

            // });

            // Error Mesg for Account Id
            if (this.validateaccountid.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.AccountIdField, detail: InputCaptureComponentmessage.ErrorMessage.AccountIdField });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.accountIdField;
                return false;
            }

            // For Separetor
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.selectedIds.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => (e.Id === 5) && e.IsMandatory === true
                        && (e.AnswerFreeText === '' || e.AnswerFreeText === null || e.AnswerFreeText.length === 0))
                });
                // return;
            }

            // });

            // Error Mesg for PL/BSeparetorS
            if (this.selectedIds.filter(x => x.Questions != 0).length !== 0) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.Mandatory, detail: InputCaptureComponentmessage.ErrorMessage.Mandatory });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.mandatory;
                return false;
            }


            // For SubTotal
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.validateSubTotal.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => (e.Id === 14 || e.Id === 15) &&
                        e.IsMandatory === true && (e.AnswerFreeText === '' || e.AnswerFreeText === null || e.AnswerFreeText.length === 0))
                });
            }



            // Error Mesg for SubTotal
            if (this.validateSubTotal.filter(x => x.Questions != 0).length !== 0) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.SubTotal, detail: InputCaptureComponentmessage.ErrorMessage.SubTotal });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.subTotal;
                return false;
            }


            // For Period Month
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.validatePeriodM.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id === 9 && (e.AnswerFreeText
                        === '' || e.AnswerFreeText === null || e.AnswerFreeText.length === 0 || this.validateDataWithRegex(e.AnswerFreeText)))
                });
            }
            // For End Date
            if (this.accountingCalendarId === 3 || this.accountingCalendarId === 4 || this.accountingCalendarId === 5) {
                if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                    this.validatePeriodM.push({
                        Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id === 33 && (e.AnswerFreeText
                            === '' || e.AnswerFreeText === null || e.AnswerFreeText.length === 0 || this.validateDataWithRegex(e.AnswerFreeText)))
                    });
                }
            }

            // Error for End date
            if (this.accountingCalendarId === 3 || this.accountingCalendarId === 4 || this.accountingCalendarId === 5) {
                if (this.validatePeriodM.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                    this.loadspinner = false;
                    this.errorModel.confirmIsDisplay = true;
                    this.errorModel.displayMessage = this.currLangTranslation.step3.messages.periodM;
                    return false;
                }
            }

            // Error Period Month
            if (this.validatePeriodM.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.blank.periodM;
                return false;
            }





            // For Period Year
            // this.applicableSourceFileTabs.filter(w => w.Questions != null && w.IsProcessed == false).forEach(element => {
            //  this.validatePeriodY.push({ Questions: element.Questions.filter(e => e.Id == 10 && (e.AnswerFreeText === "" || e.AnswerFreeText
            // === null || e.AnswerFreeText.length == 0 || this.validateDataWithRegex(e.AnswerFreeText))) })
            // });


            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                // this.validatePeriodY.push({ Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id == 10 && (e.AnswerFreeText
                // === "" || e.AnswerFreeText === null || e.AnswerFreeText.length == 0 || this.validateDataWithRegex(e.AnswerFreeText))) })

                this.validatePeriodY.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id === 10 &&
                        (this.validateDataWithRegex(e.AnswerFreeText)))
                });
            }

            // Error Period Year
            if (this.validatePeriodY.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.PeriodM, detail: InputCaptureComponentmessage.ErrorMessage.PeriodM });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.periodM;
                return false;
            }

            // For BS1
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.validateBS1.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id === 7 && (e.AnswerFreeText === ''
                        || e.AnswerFreeText === null || e.AnswerFreeText.length === 0 || this.validateDataWithRegex(e.AnswerFreeText)))
                });
            }
            // this.validateBS1.push({ Questions: element.Questions.filter(e => e.Id == 7 && (e.AnswerFreeText === "" || e.AnswerFreeText ===
            // null || e.AnswerFreeText.length == 0 || this.validateDataWithRegex(e.AnswerFreeText))) })



            // Error BS1
            if (this.validateBS1.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.BusinessSegment, detail: InputCaptureComponentmessage.ErrorMessage.BusinessSegment });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.businessSegment;
                return false;
            }

            // For BS2
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.validateBS2.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id === 8 && (e.AnswerFreeText === '' ||
                        e.AnswerFreeText === null || e.AnswerFreeText.length === 0 || this.validateDataWithRegex(e.AnswerFreeText)))
                });
            }

            // Error BS2
            if (this.validateBS2.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.BusinessSegment, detail: InputCaptureComponentmessage.ErrorMessage.BusinessSegment });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.businessSegment;
                return false;
            }

            // For BS for multiple periods
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.selectedIds.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => (e.Id === this.entityQuestionIdBS ||
                        e.Id === this.commaPeriodMonthId || e.Id === this.commaPeriodYearId || e.Id === this.commaNoPeriodMonthId || e.Id === this.commaEndDateId || e.Id === this.commaNoEndDateId ||
                        e.Id === this.commaNoPeriodYearId) && e.IsMandatory === true && (e.AnswerFreeText === '' || e.AnswerFreeText === null ||
                            e.AnswerFreeText.length === 0))
                });
                // return;
            }



            // Error BS for multiple periods
            if (this.selectedIds.filter(x => x.Questions != 0).length !== 0) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.Mandatory, detail: InputCaptureComponentmessage.ErrorMessage.Mandatory });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.mandatory;
                return false;
            }




            // For Period Month VALIDATION
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.validateCellForPeriodMonth.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id === 24 &&
                        (e.AnswerFreeText === '' || e.AnswerFreeText === null || e.AnswerFreeText.length === 0 ||
                            this.validateDataWithRegex(e.AnswerFreeText)))
                });
            }

            // Error Period Month VALIDATION
            if (this.validateCellForPeriodMonth.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.PeriodM, detail: InputCaptureComponentmessage.ErrorMessage.PeriodM });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.validatePeriodMonthYearDescription;
                return false;
            }


            // For End date VALIDATION
            if (this.accountingCalendarId === 3 || this.accountingCalendarId === 4 || this.accountingCalendarId === 5) {
                if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                    this.validateCellForPeriodMonth.push({
                        Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id === 32 &&
                            (e.AnswerFreeText === '' || e.AnswerFreeText === null || e.AnswerFreeText.length === 0 ||
                                this.validateDataWithRegex(e.AnswerFreeText)))
                    });

                }
            }


            // Error End date VALIDATION
            if (this.accountingCalendarId === 3 || this.accountingCalendarId === 4 || this.accountingCalendarId === 5) {
                if (this.validateCellForPeriodMonth.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                    this.loadspinner = false;
                    this.errorModel.confirmIsDisplay = true;
                    this.errorModel.displayMessage = this.currLangTranslation.step3.messages.validatePeriodMonthYearDescription;
                    return false;
                }
            }


            // For Period Year VALIDATION
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.validateCellForPeriodYear.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id === 25 &&
                        (e.AnswerFreeText === '' || e.AnswerFreeText === null || e.AnswerFreeText.length === 0 ||
                            this.validateDataWithRegex(e.AnswerFreeText)))
                });
            }



            // Error Period Year VALIDATION
            if (this.validateCellForPeriodYear.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.PeriodM, detail: InputCaptureComponentmessage.ErrorMessage.PeriodM });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.validatePeriodMonthYearDescription;
                return false;
            }

            // For Income statement Amount
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.validateIncomeA.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => e.Id === 12 && (e.AnswerFreeText ===
                        '' || e.AnswerFreeText === null || e.AnswerFreeText.length === 0 || this.validateDataWithRegex_dash(e.AnswerFreeText)))
                });
            }

            // Error Income statement Amount
            if (this.validateIncomeA.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.statementAmount, detail: InputCaptureComponentmessage.ErrorMessage.statementAmount });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.statementAmount;
                return false;
            }

            // For Balance  statement Amount
            if (this.applicableSourceFileTabs[i].Questions != null && this.applicableSourceFileTabs[i].IsProcessed === false) {
                this.validateIncomeB.push({
                    Questions: this.applicableSourceFileTabs[i].Questions.filter(e => (e.Id === 11 || e.Id === 27) &&
                        (e.AnswerFreeText === '' || e.AnswerFreeText === null || e.AnswerFreeText.length === 0 ||
                            this.validateDataWithRegex_dash(e.AnswerFreeText)))
                });
            }

            // Error Balance statement Amount
            if (this.validateIncomeB.filter(x => x.Questions != 0).length !== 0 || this.validateAnswerFreeText !== true) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.statementAmount, detail: InputCaptureComponentmessage.ErrorMessage.statementAmount });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.statementAmount;
                return false;
            }


        }

        if (this.applicableSourceFileTabs.filter(w => w.Questions != null && w.IsUserInputSaved === false).length > 0) {
            if (this.applicableSourceFileTabs.filter(w => w.Questions == null && w.IsProcessed === false).length > 0) {
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: InputCaptureComponentmessage.
                // ErrorMessage.Blank, detail: InputCaptureComponentmessage.ErrorMessage.Blank });
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step3.messages.blank;
                return false;
            }
        }

        if (this.applicableSourceFileTabs.filter(w => w.IsProcessed === false).length !== 0) {
            this.userInputsService.saveUserinputsQuestionAnswer(this.applicableSourceFileTabs).subscribe((resp) => {
                this.loadspinner = false;
                this.messageService.add({
                    key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success, summary: this.currLangTranslation.severitymessage.notification,
                    detail: this.currLangTranslation.inputCaptureComponentmessage.SuccessMessage.AddDataMsg, life: 10000
                });
                this.router.navigate(['/engagement/', this.engagementId, 'scenario']);
            }, (error) => {
                this.logger.error(error);
                this.messageService.add({
                    key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                    detail: this.currLangTranslation.severitymessage.Error, sticky: true, closable: true
                });
                this.loadspinner = false;
            });
        } else {
            this.loadspinner = false;
            this.router.navigate(['/engagement/', this.engagementId, 'scenario']);
        }

    }

    private getMappingType() {
        let mappingtype = '';
        if (this.currentSourceFileTab.Questions) {
            const account = this.currentSourceFileTab.Questions.find(x => x.Id === 1);
            if (account && account.AnswerFreeText != null) {
                if (account.AnswerFreeText.filter(x => x === '10').length > 0) {
                    mappingtype = 'pl';
                }
                if (account.AnswerFreeText.filter(x => x === '11').length > 0) {
                    if (mappingtype !== '') {
                        mappingtype = mappingtype + ',bs';
                    } else {
                        mappingtype = 'bs';
                    }
                }
            }
        }
        return mappingtype;
    }

    private getAmountQuestionsOnConditions() {
        let mappingtype: string;
        let bs1RangeExist = false;
        let bs2RangeExist = false;
        let pmRangeExist = false;
        let pyRangeExist = false;
        let range_pmExist = false;
        let range_pyExist = false;
        let range_endDateExist = false;
        let endDateRangeExists = false;

        const bs1 = this.currentSourceFileTab.Questions.find(x => x.Id === this.entity1QuestionId);
        const bs2 = this.currentSourceFileTab.Questions.find(x => x.Id === this.entity2QuestionId);
        const plbs = this.currentSourceFileTab.Questions.find(x => x.Id === this.plbsAmountId);


        if (bs1) {
            // bs2RangeExist = true;
            if (bs1.AnswerFreeText !== undefined && bs1.AnswerFreeText.indexOf(':') > 0) {
                if (plbs) {
                    if (plbs.AnswerFreeText !== undefined) {
                        plbs.AnswerFreeText = undefined;
                    }
                }
                bs1RangeExist = true;
            }
        }
        if (bs2) {
            bs2RangeExist = false;
            if (bs2.AnswerFreeText !== undefined && bs2.AnswerFreeText.indexOf(':') > 0) {
                if (plbs) {
                    if (plbs.AnswerFreeText !== undefined) {
                        plbs.AnswerFreeText = undefined;
                    }
                }
                bs2RangeExist = true;
            }
        }

        const pm = this.currentSourceFileTab.Questions.find(x => x.Id === 9);
        const py = this.currentSourceFileTab.Questions.find(x => x.Id === 10);
        const end_date = this.currentSourceFileTab.Questions.find(x => x.Id === 33);
        const range_pm = this.currentSourceFileTab.Questions.find(x => x.Id === 24);
        const range_py = this.currentSourceFileTab.Questions.find(x => x.Id === 25);
        const range_endDate = this.currentSourceFileTab.Questions.find(x => x.Id === 31);
        const range_endDate2 = this.currentSourceFileTab.Questions.find(x => x.Id === 32);
        if (pm) {
            if (pm.AnswerFreeText !== undefined && pm.AnswerFreeText?.indexOf(':') > 0) {
                if (plbs) {
                    if (plbs.AnswerFreeText !== undefined) {
                        plbs.AnswerFreeText = undefined;
                    }
                }
                pmRangeExist = true;
            }
        }
        if (py) {
            if (py.AnswerFreeText !== undefined && py.AnswerFreeText.indexOf(':') > 0) {
                if (plbs) {
                    if (plbs.AnswerFreeText !== undefined) {
                        plbs.AnswerFreeText = undefined;
                    }
                }
                pyRangeExist = true;
            }
        }
        // 445 calendar business engagement
        if (end_date) {
            if (end_date.AnswerFreeText !== undefined && end_date.AnswerFreeText.indexOf(':') > 0) {
                if (plbs) {
                    if (plbs.AnswerFreeText !== undefined) {
                        plbs.AnswerFreeText = undefined;
                    }
                }
                endDateRangeExists = true;
            }
        }
        if (range_pm) {
            if (range_pm.AnswerFreeText !== undefined && range_pm.AnswerFreeText.indexOf(':') > 0) {
                if (plbs) {
                    if (plbs.AnswerFreeText !== undefined) {
                        plbs.AnswerFreeText = undefined;
                    }
                }
                range_pmExist = true;
            }
        }
        if (range_py) {
            if (range_py.AnswerFreeText !== undefined && range_py.AnswerFreeText.indexOf(':') > 0) {
                // To clear the answerfreetext after multiple referece.
                if (plbs) {
                    if (plbs.AnswerFreeText !== undefined) {
                        plbs.AnswerFreeText = undefined;
                    }
                }
                range_pyExist = true;
            }
        }
        if (range_endDate) {
            if (range_endDate.AnswerFreeText !== undefined && range_endDate.AnswerFreeText.indexOf(':') > 0) {
                if (plbs) {
                    if (plbs.AnswerFreeText !== undefined) {
                        plbs.AnswerFreeText = undefined;
                    }
                }
                range_endDateExist = true;
            }
        }
        if (range_endDate2) {
            if (range_endDate2.AnswerFreeText !== undefined && range_endDate2.AnswerFreeText.indexOf(':') > 0) {
                if (plbs) {
                    if (plbs.AnswerFreeText !== undefined) {
                        plbs.AnswerFreeText = undefined;
                    }
                }
                range_endDateExist = true;
            }
        }
        mappingtype = this.getMappingType();
        if (mappingtype !== '' && !(pmRangeExist || pyRangeExist || bs1RangeExist || bs2RangeExist || range_pmExist || range_pyExist || range_endDateExist || endDateRangeExists)) {
            // if (mappingtype !== '' && !(pmRangeExist || bs1RangeExist || bs2RangeExist)) {
            this.getAmountQuestions(mappingtype);
            this.getQuestionBasedOnSelectMapping(mappingtype);
        } else {
            this.getQuestionBasedOnSelectMapping(mappingtype);
            this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions
                .filter(x => x.Id !== this.bsAmountId && x.Id !== this.plAmountId && x.Id !== this.plbsAmountId && x.Id !== this.firstValue);
        }
    }

    onTextChange(questionsEntity) {
        this.selectedQuestion = questionsEntity;
        if (questionsEntity.Id !== this.bsAmountId && questionsEntity.Id !== this.plAmountId && questionsEntity.Id !== this.plOrbsAmountId) {
            if (this.selectedQuestion.Id === this.plAccountId || this.selectedQuestion.Id === this.bsAccountId || this.selectedQuestion.Id === 4
                || this.selectedQuestion.Id === 5) {
                this.getSeperatorQuestionBaseOnConditions();
            }
            if (questionsEntity.Id === this.entity1QuestionId || questionsEntity.Id === this.entity2QuestionId) {
                this.getAmountRangeAndNonRangeQuestions();
            }
            this.getAmountQuestionsOnConditions();


        }
    }

    onSelectionRadio(questionsEntity, questionOption) {
        // Need to put condition for pl/bs amount
        // this.bs_Sheet_Yes= false;
        questionsEntity.QuestionParentAnswer = questionOption.OptionID;
        if (questionOption.OptionCaption === 'Cumulative') {
            this.radionumber = questionOption.OptionID;
            this.groupsList.filter((val, i) => {
                if (val.groupName === this.currentSourceFileTab.GroupName) {
                    val.radioValue = this.radionumber;
                }
            });
        } else if (questionOption.OptionCaption === 'Sequential') {
            this.radionumber = questionOption.OptionID;
            this.groupsList.filter((val, i) => {
                if (val.groupName === this.currentSourceFileTab.GroupName) {
                    val.radioValue = this.radionumber;
                }
            });
        }
        // This condition is written so that by default select of pl/bs amount select to null.
        if (questionsEntity.QuestionType === 4 || questionsEntity.QuestionType === 3 && (questionOption.OptionID === 5 ||
            questionOption.OptionID === 6)) {
            if (this.bs_Sheet_Yes !== false) {
                this.bs_Sheet_Yes = true;
            }
        }

        if (questionsEntity.QuestionType !== 4) {
            // Handel the condition for NONE

            if (questionsEntity.QuestionType === 3 && questionOption.OptionID === 13) {
                // this.bs_Sheet_Yes = true;
                if (this.bs_Sheet_Yes !== false) {
                    this.bs_Sheet_Yes = true;
                }
                this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions
                    .filter(x => x.Id !== 14 && x.QuestionType !== 7);
                this.getAmountQuestionsOnConditions();
                return;
            }
            // Handel the condition for NONE
            if (questionsEntity.QuestionType === 3 && questionOption.OptionID === 13) {
                if (this.bs_Sheet_Yes !== false) {
                    this.bs_Sheet_Yes = true;
                }
                this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions
                    .filter(x => x.Id !== 15 && x.QuestionType !== 7);
                this.getAmountQuestionsOnConditions();
                return;
            }
            // check the "Does each BS has multiple periods in same sheet? Qs to clear deault selection of PL/BS amount"
            if (questionsEntity.Id === this.entityQuestionIdBS) {
                const plbs = this.currentSourceFileTab.Questions.find(x => x.Id === this.plbsAmountId);
                if (plbs) {
                    if (plbs.AnswerFreeText !== null) {
                        plbs.AnswerFreeText = null;
                    }
                }
            }
            if (questionsEntity.Id !== this.plbsAmountId) {
                if (questionsEntity.QuestionType === 1 && questionOption.OptionID === 1) {
                    this.bs_Sheet_Yes = true;
                    // aaa
                    this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions
                        .filter(x => x.Id !== this.plbsAmountId && x.Id !== this.firstValue && x.Id !== this.plAmountId && x.Id !== this.bsAmountId);
                    this.getAmountQuestionsOnConditions();
                    // return;
                }
            }
            if (questionsEntity.Id === this.plbsAmountId) {
                if (questionsEntity.QuestionType === 1) {
                    this.IsNotAmountCall = true;
                }
            }


            // Need to display pl/bs amount on NO condition.
            if (questionsEntity.Id === this.entityQuestionIdBS) {
                if (questionsEntity.QuestionType === 1 && questionOption.OptionID === 2) {
                    this.bs_Sheet_Yes = false;
                }
            }
            // This logic is written to bring childQs.
            this.finalchildQsById = [];
            // New Logic


            this.finalchildQsById = JSON.parse(JSON.stringify(this.childQsById.filter(e => e.QuestionParent === questionsEntity.Id &&
                e.QuestionParentAnswer === questionOption.OptionID))); // New

            if (this.finalchildQsById.length > 0) {
                this.currentSourceFileTab.Questions =
                    this.currentSourceFileTab.Questions.filter(f => f.QuestionParent !== questionsEntity.Id);
                if (this.accountingCalendarId !== 1 && this.accountingCalendarId !== 2) {
                    this.finalchildQsById = this.finalchildQsById.filter(val => val.Id !== 24 && val.Id !== 25 && val.Id !== 21 && val.Id !== 22);
                } else {
                    this.finalchildQsById = this.finalchildQsById.filter(val => val.Id !== 31 && val.Id !== 32);
                }

                let insertAt = this.currentSourceFileTab.Questions.findIndex(x => x.Id === questionsEntity.Id);

                this.finalchildQsById.forEach(x => {
                    // Condition for handel period month on Yes and No
                    if (x.Id === this.commaPeriodMonthId) {
                        if ((this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) || (this.currentSourceFileTab.EntityLevel2Id ===
                            this.sheetCoverageId)) {
                            if (this.currentSourceFileTab.PeriodId === this.sheetCoverageId) {
                                insertAt++;
                                this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                            }
                        }
                    } else if (x.Id === this.commaNoPeriodMonthId) {
                        if ((this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) || (this.currentSourceFileTab.EntityLevel2Id ===
                            this.sheetCoverageId)) {
                            if (this.currentSourceFileTab.PeriodId === this.sheetCoverageId) {
                                insertAt++;
                                this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                            }
                        }
                    } else if (x.Id === this.commaPeriodYearId) {
                        if ((this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) || (this.currentSourceFileTab.EntityLevel2Id ===
                            this.sheetCoverageId)) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId) {
                                insertAt++;
                                this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                            }
                        }
                    } else if (x.Id === this.commaNoPeriodYearId) {
                        if ((this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) || (this.currentSourceFileTab.EntityLevel2Id ===
                            this.sheetCoverageId)) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId) {
                                insertAt++;
                                this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                            }
                        }
                    } else if (x.Id === this.commaEndDateId) {
                        if ((this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) || (this.currentSourceFileTab.EntityLevel2Id ===
                            this.sheetCoverageId)) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId) {
                                insertAt++;
                                this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                            }
                        }

                    } else if (x.Id === this.commaNoEndDateId) {
                        if ((this.currentSourceFileTab.EntityLevel1Id === this.sheetCoverageId) || (this.currentSourceFileTab.EntityLevel2Id ===
                            this.sheetCoverageId)) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId) {
                                insertAt++;
                                this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                            }
                        }
                    } else {
                        insertAt++;
                        this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                    }
                });
                this.currentSourceFileTab.Questions.map((resp) => {
                    this.finalengagementQs = [];
                    this.finalengagementQs = this.engagementQs.filter(w => w.TypeID === resp.QuestionType);
                    resp.QuestionOptions = this.finalengagementQs;
                });
            }
            this.getAmountQuestionsOnConditions();
        }
    }

    onSelectionChange(questionsEntity, questionOption, event) {

        questionsEntity.AnswerFreeText = questionsEntity.AnswerFreeText.filter(function (el) {
            return el != '';
        });

        if (questionsEntity.QuestionType !== 7) {
            if (questionsEntity.QuestionType === 5 && questionsEntity.AnswerFreeText.filter(x => x === '10').length === 0) {
                this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions
                    .filter(x => x.Id !== 2 && x.Id !== 27);

                this.getAmountQuestionsOnConditions();
                if (event === false) {
                    if (this.previousTabId === this.currentSourceFileTabId) {
                        this.previousTabId = null;
                    }
                }
                return;
            }

            questionsEntity.QuestionParentAnswer = questionOption.OptionID;
            this.ChildQslist = [];
            // New Logic
            this.ChildQslist = JSON.parse(JSON.stringify(this.childQsById.filter(e => e.QuestionParent === questionsEntity.Id &&
                e.QuestionParentAnswer === questionOption.OptionID))); // New
            const isBSAnswer = this.currentSourceFileTab.Questions.filter(x => x.Id === this.bsAccountId);
            if (this.ChildQslist.length > 0) {
                // this.currentSourceFileTab.Questions =
                //  this.currentSourceFileTab.Questions.filter(f => f.QuestionParent !== questionsEntity.Id);

                let insertAt = this.currentSourceFileTab.Questions.findIndex(x => x.Id === questionsEntity.Id);
                this.ChildQslist.forEach(x => {
                    insertAt++;
                    this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                });

                // New Code
                this.currentSourceFileTab.Questions.map((resp, i) => {
                    this.finalengagementQs = [];
                    this.finalengagementQs = this.engagementQs.filter(w => w.TypeID === resp.QuestionType);
                    resp.QuestionOptions = this.finalengagementQs;
                    if ((this.radionumber == null && (this.previousTabId === this.currentSourceFileTab.Id || this.previousTabId == null))) {
                        if (resp.Id === 2 && resp.AnswerFreeText === undefined) {
                            resp.AnswerFreeText = 7;
                            this.radionumber = 7;
                            this.groupsList.push({ 'groupName': this.currentSourceFileTab.GroupName, 'tabName': this.currentSourceFileTab.TabName, 'radioValue': this.radionumber, 'firstTabEnable': true });
                            this.previousTabId = this.currentSourceFileTab.Id;
                            this.plStatus = false;
                        }
                    } else {
                        if (resp.Id === 2) {
                            if (this.groupsList.length > 0 && !event) {
                                this.groupsList = this.groupsList.filter(val => val.tabName !== this.currentSourceFileTab.TabName);
                            }
                            if (this.radionumber != null && this.previousTabId == null) {
                                this.plStatus = false;
                                resp.AnswerFreeText = this.radionumber;
                                this.previousTabId = this.currentSourceFileTab.Id;
                            } else {
                                if (this.groupsList.filter(val => val.groupName === this.currentSourceFileTab.GroupName).length > 0) {
                                    this.plStatus = true;
                                    this.groupsList.filter((values, i) => {
                                        if ((values.tabName == this.currentSourceFileTab.TabName ||
                                            values.tabName == this.currentSourceFileTab.Id) &&
                                            values.groupName === this.currentSourceFileTab.GroupName) {
                                            this.groupsList[i].firstTabEnable = true;
                                            this.plStatus = false;
                                        } else {
                                            if (values.groupName === this.currentSourceFileTab.GroupName) {
                                                this.radionumber = values.radioValue;
                                            }
                                        }
                                    });

                                } else {
                                    this.radionumber = 7;
                                    this.groupsList.push({ 'groupName': this.currentSourceFileTab.GroupName, 'tabName': this.currentSourceFileTab.TabName, 'radioValue': this.radionumber, 'firstTabEnable': true });
                                    this.plStatus = false;
                                }
                                resp.AnswerFreeText = this.radionumber;
                            }
                        }
                    }
                });
            }
            this.getAmountQuestionsOnConditions();
        }
    }

    onSeperatorBlur(questionsEntity) {
        let index = 0;
        let id = '';
        let desc = '';
        if (this.accDescIdPreview) {
            index = this.accDescIdPreview.indexOf(questionsEntity.AnswerFreeText);
            id = this.accDescIdPreview.substring(0, index);
            desc = this.accDescIdPreview.substring(index + 1);
            const existingIdIndex = this.accDescIdPreview.indexOf('Id:');
            const existingDescIndex = this.accDescIdPreview.indexOf('Desc:');
            if (index > 0) {
                if (existingIdIndex !== -1 && existingDescIndex !== -1) {
                    this.accDescIdPreview = this.accDescIdPreview;
                    this.showDescIdPreview = true;
                } else {
                    this.accDescIdPreview = 'Id: ' + id + ', Desc: ' + desc;
                    this.showDescIdPreview = true;
                }

            }
        }
    }

    clickselectionongrid(e: any): void {
        if (!e.cell) { return; }
        this.selectedCell = e.cell;

        if (this.selectedQuestion.AnswerFreeText != null && this.selectedQuestion.AnswerFreeText !== '') {
            if (this.selectedQuestion.AnswerFreeText.substring(this.selectedQuestion.AnswerFreeText.length - 1) === '+'
                || this.selectedQuestion.AnswerFreeText.substring(this.selectedQuestion.AnswerFreeText.length - 1) === '-') {
                this.selectedQuestion.AnswerFreeText += e.cell.header.title + (e.cell.rowIndex + 1);
                // this.selectedQuestion.AnswerFreeText += String.fromCharCode(e.cell.columnIndex + 65) + (e.cell.rowIndex + 1);
            } else {
                this.selectedQuestion.AnswerFreeText += ':' + e.cell.header.title + (e.cell.rowIndex + 1);
                // this.selectedQuestion.AnswerFreeText += ':' + String.fromCharCode(e.cell.columnIndex + 65) + (e.cell.rowIndex + 1);
            }
        } else {
            this.selectedQuestion.AnswerFreeText = e.cell.header.title + (e.cell.rowIndex + 1);
            // this.selectedQuestion.AnswerFreeText = String.fromCharCode(e.cell.columnIndex + 65) + (e.cell.rowIndex + 1);
        }

        if (this.selectedQuestion.Id === this.plAccountId || this.selectedQuestion.Id === this.bsAccountId || this.selectedQuestion.Id ===
            4 || this.selectedQuestion.Id === 5) {

            this.accDescIdPreview = e.cell.data[e.cell.columnIndex];
            this.getSeperatorQuestionBaseOnConditions();
        }
        if (this.selectedQuestion.Id !== this.bsAmountId && this.selectedQuestion.Id !== this.plAmountId && this.selectedQuestion.Id !==
            this.plOrbsAmountId) {
            this.getAmountQuestionsOnConditions();
        }
        if (this.selectedQuestion.Id === this.entity1QuestionId || this.selectedQuestion.Id === this.entity2QuestionId) {
            this.getAmountRangeAndNonRangeQuestions();
        }
    }


    private getSeperatorQuestionBaseOnConditions() {
        let descAnswerBS = QuestionsModel;
        let descAnswerPL = QuestionsModel;
        const bsQuestion = this.currentSourceFileTab.Questions.find(x => x.Id === this.bsAccountId);
        const plQuestion = this.currentSourceFileTab.Questions.find(x => x.Id === this.plAccountId);
        if (bsQuestion != null && bsQuestion.AnswerFreeText != null) {
            descAnswerBS = bsQuestion.AnswerFreeText.replace(/[0-9]/g, '').toUpperCase();
        }
        if (plQuestion != null && plQuestion.AnswerFreeText != null) {
            descAnswerPL = plQuestion.AnswerFreeText.replace(/[0-9]/g, '').toUpperCase();
        }

        if (this.currentSourceFileTab.Questions.find(x => x.Id === 4).AnswerFreeText != null) {
            this.idAnswer = this.currentSourceFileTab.Questions.find(x => x.Id === 4).AnswerFreeText.replace(/[0-9]/g, '').toUpperCase();
        }

        if ((descAnswerBS !== undefined || descAnswerPL !== undefined) && this.idAnswer !== undefined && ((descAnswerBS === this.idAnswer) ||
            (descAnswerPL === this.idAnswer))) {
            this.separatorlist = [];
            this.separatorlist = JSON.parse(JSON.stringify(this.childQsById.filter(e => e.QuestionParent === 3 && e.QuestionParentAnswer ===
                0))); // New
            if (this.separatorlist.length > 0) {
                this.currentSourceFileTab.Questions =
                    this.currentSourceFileTab.Questions.filter(f => f.Id !== 5);
                let insertAt = this.currentSourceFileTab.Questions.findIndex(x => x.Id === 4);
                this.separatorlist.forEach(x => {
                    insertAt++;
                    this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                });
            }
        } else {
            this.currentSourceFileTab.Questions =
                this.currentSourceFileTab.Questions.filter(f => f.Id !== 5);
        }
    }

    selectedInput(event: any, engagementQuestion: QuestionsModel) {
        this.selectedQuestion = engagementQuestion;
    }

    previewTab(sourceFileId, sourceFileTab, sourcefilename) {
        this.loadspinner = false;
        this.previewloadspinner = true;
        this.sourcefilename = sourcefilename.replace('.xlsx', '').replace('.xls', '');
        const xhr = this.engagementService.getSourceFilesContent(sourceFileId);
        const reader: FileReader = new FileReader();
        let binary = '';
        FileReader.prototype.readAsBinaryString = undefined;
        if (FileReader.prototype.readAsBinaryString === undefined) {
            FileReader.prototype.readAsBinaryString = function (fileData) {
                this.previewloadspinner = false;
                const pt = this;
                reader.onload = function (e) {
                    let ia = null;
                    let length = 0;
                    if (e) {
                        ia = new Uint8Array(e.target['result'] as ArrayBuffer);
                        length = ia.length;
                    }
                    for (let i = 0; i < length; i++) {
                        binary += String.fromCharCode(ia[i]);
                    }
                };

                reader.readAsArrayBuffer(fileData);
            };
        }
        xhr.onreadystatechange = function () {

            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    const blob = new Blob([xhr.response], { type: contentType });
                    reader.readAsBinaryString(blob);
                }
            }
        };
        xhr.send();

        reader.onloadend = () => {
            this.previewloadspinner = false;

            if (binary === '') {
                this.filebase64data = reader.result;

            } else {
                this.filebase64data = binary.toString();
            }
            this.workSheets = this.excelService.readWorkSheetNames(this.filebase64data);
            // var selectedregion = localStorage.getItem('selectedregion');
            const data = this.excelService.readWorkBookToArrayForCanvasDataGridBinary(this.filebase64data,
                this.workSheets.filter(workSheet => workSheet === '' + sourceFileTab)[0], this.regionId + '');

            if (data !== undefined && data !== null) {

                this.isSheetRowsExceeded = false;
                this.myGrid.data = data;
                this.recordMessage = '';

            }

            this.loadspinner = false;
        };

    }

    closeEventworkallocation($event) {
        this.confirmdisplay = $event;
    }
    previous() {
        this.router.navigate(['/engagement/', this.engagementId, 'previewsourcefile'], { queryParams: { order: '2' } });

    }

  previousButton() {
      this.confirmdisplay = false;
      this.router.navigate(['/engagement/', this.engagementId, 'previewsourcefile']);
    }

    applyToAllTabs(event) {
        if (event.checked) {
            this.isApplyToAllTabsChecked = true;
            this.currentSourceFileTab.IsLoaded = true;
            for (let index = 0; index < this.applicableSourceFileTabs.length; index++) {
                if (this.currentSourceFileTab.Id === this.applicableSourceFileTabs[index].Id) {
                    this.applicableSourceFileTabs[index].ApplyToAllTabs = true;
                }
                if (this.applicableSourceFileTabs[index].IsProcessed !== true
                    && this.currentSourceFileTab.GroupName === this.applicableSourceFileTabs[index].GroupName
                    && this.currentSourceFileTab.Id !== this.applicableSourceFileTabs[index].Id) {
                    this.applicableSourceFileTabs[index].IsAppliedFromSourceTab = true;
                    // used jsonstringy for deep copy without any reference
                    this.applicableSourceFileTabs[index].Questions = JSON.parse(JSON.stringify(this.currentSourceFileTab.Questions));
                    this.applicableSourceFileTabs[index].IsLoaded = true;
                }
            }
        } else {
            this.isApplyToAllTabsChecked = false;
            for (let index = 0; index < this.applicableSourceFileTabs.length; index++) {
                if (this.currentSourceFileTab.GroupName === this.applicableSourceFileTabs[index].GroupName) {
                    this.applicableSourceFileTabs[index].IsAppliedFromSourceTab = false;
                    this.applicableSourceFileTabs[index].ApplyToAllTabs = false;
                }
            }
        }
    }
    checkProcessingData() {

        this.userInputsService.checkProcessingData(this.engagementId)
            .subscribe((response: any) => {

                if (response.status === 'success') {

                    this.checkData = 1;

                    this.deleteProcessingData();
                }
                else {
                    this.checkData = 0;
                    this.deleteProcessingData();
                }
            }, error => {
                this.loadspinner = false;

                this.messageService.add({
                    key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                    detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
                });
            }
      );
      this.auditingService.addAudit(this.engagementId, FunctionalityNames.ModifyUserInput).subscribe();
    }

    deleteProcessingData() {
        if (!this.isResetProcessingDisabled) {

            this.display = true;
            // this.confirmationService.confirm({
            //     message: this.currLangTranslation.step3.messages.confirmReset,
            //     header: this.currLangTranslation.labels.warning,
            //     acceptLabel: this.currLangTranslation.actionButtons.yes,
            //     rejectLabel: this.currLangTranslation.actionButtons.no,
            //     accept: () => {
            //         this.loadspinner = true;

            //         this.userInputsService.deleteProcessingData(this.engagementId)
            //             .subscribe((response: any) => {

            //                 if (response.status === 'success') {

            //                     if (this.checkData > 0) {
            //                         this.previous();
            //                     }
            //                     else
            //                         this.messageService.add({
            //                             key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success,
            //                             summary: this.currLangTranslation.severitymessage.notification,
            //                             detail: this.currLangTranslation.inputCaptureComponentmessage.SuccessMessage.ResetProcessing, sticky: true,
            //                             closable: true
            //                         });

            //                     this.loadspinner = false;
            //                     this.applicableSourceFileTabs.forEach(x => { x.IsProcessed = false; });
            //                     this.isResetProcessingDisabled = true;

            //                 } else {
            //                     this.loadspinner = false;

            //                     this.messageService.add({
            //                         key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
            //                         detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
            //                     });
            //                 }

            //             }, error => {
            //                 this.loadspinner = false;

            //                 this.messageService.add({
            //                     key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
            //                     detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
            //                 });
            //             }

            //             );

            //     },
            //     reject: () => { }
            // });
        }
    }

    confirm() {
        this.loadspinner = true;

        this.userInputsService.deleteProcessingData(this.engagementId)
            .subscribe((response: any) => {

                if (response.status === 'success') {

                    if (this.checkData > 0) {
                        this.previous();
                    }
                    else
                        this.messageService.add({
                            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success,
                            summary: this.currLangTranslation.severitymessage.notification,
                            detail: this.currLangTranslation.inputCaptureComponentmessage.SuccessMessage.ResetProcessing, sticky: true,
                            closable: true
                        });

                    this.loadspinner = false;
                    this.display = false;
                    this.applicableSourceFileTabs.forEach(x => { x.IsProcessed = false; });
                    this.isResetProcessingDisabled = true;

                } else {
                    this.loadspinner = false;
                    this.display = false;
                    this.messageService.add({
                        key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                        detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
                    });
                }

            }, error => {
                this.loadspinner = false;
                this.display = false;

                this.messageService.add({
                    key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                    detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
                });
            }

            );
    }

    reject() {
        this.display = false;
    }

    cancel() {
        this.display = false;
    }

    private getAmountRangeAndNonRangeQuestions() {
        let bs1RangeExist = false;
        let bs2RangeExist = false;
        const bs1 = this.currentSourceFileTab.Questions.find(x => x.Id === this.entity1QuestionId);
        const bs2 = this.currentSourceFileTab.Questions.find(x => x.Id === this.entity2QuestionId);

        if (bs1) {
            // bs2RangeExist = true;
            if (bs1.AnswerFreeText !== null && bs1.AnswerFreeText.indexOf(':') > 0) {
                bs1RangeExist = true;
            }

        }
        if (bs2) {
            bs2RangeExist = false;
            if (bs2.AnswerFreeText !== null && bs2.AnswerFreeText.indexOf(':') > 0) {
                bs2RangeExist = true;
            }
        }

        if (bs1RangeExist === false && bs2RangeExist === false) {
            this.bs_Sheet_Yes = false;
        }
        if (bs2 && bs2.AnswerFreeText != null && bs2.AnswerFreeText !== '') {
            if (bs2RangeExist) {
                if (!this.currentSourceFileTab.Questions.find(x => x.Id === 20)) {
                    this.getAmountQuestionsBasedOnRange(this.entity2QuestionId);
                }
            } else {
                this.getAmountQuestionsBasedOnNonRange(this.entity2QuestionId);
            }
        } else if (bs1 && bs1.AnswerFreeText != null && bs1.AnswerFreeText !== '' && !bs2) {
            // when we have does business segament have multiple periods this loop will execute
            if (bs1RangeExist) {
                if (!this.currentSourceFileTab.Questions.find(x => x.Id === 20)) {
                    this.getAmountQuestionsBasedOnRange(this.entity1QuestionId);
                }
            } else {
                this.getAmountQuestionsBasedOnNonRange(this.entity1QuestionId);
            }
        } else {
            // when we remove value from business segment box end dates should be hide
            this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.entityQuestionIdBS && x.Id !== 24
                && x.Id !== 25 && x.Id !== this.periodMonthId && x.Id !== this.periodYearId && x.Id !== 21 && x.Id !== 22 && x.Id !== 33 && x.Id !== 31 && x.Id !== 32);
        }
    }

    getAmountQuestionsBasedOnRange(questionId: number) {

        this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.entityQuestionIdBS && x.Id !== 24
            && x.Id !== 25 && x.Id !== 9 && x.Id !== 10 && x.Id !== 21 && x.Id !== 22 && x.Id !== 31 && x.Id !== 32 && x.Id !== 33);
        const rangeAmountQuestion = JSON.parse(JSON.stringify(this.childQsById.filter(e => e.QuestionParent === 7))); // New
        if (rangeAmountQuestion.length > 0) {
            this.currentSourceFileTab.Questions =
                this.currentSourceFileTab.Questions.filter(f => f.QuestionParent !== 7);
            let insertAt = this.currentSourceFileTab.Questions.findIndex(x => x.Id === questionId);

            rangeAmountQuestion.forEach(x => {
                insertAt++;
                if (this.currentSourceFileTab.PeriodId === 3 || this.currentSourceFileTab.PeriodIdYear === 3) {
                    this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                }

            });
            this.currentSourceFileTab.Questions.map((resp) => {
                // New Code
                this.finalengagementQs = [];
                this.finalengagementQs = this.engagementQs.filter(w => w.TypeID === resp.QuestionType);

                resp.QuestionOptions = this.finalengagementQs;
            });
        }
    }

    getAmountQuestionsBasedOnNonRange(questionId: number) {
        if (this.selectedQuestion) {
            let nonrangeAmountQuestion;
            if (this.selectedQuestion.Id !== this.periodMonthId && this.selectedQuestion.Id !== this.periodYearId) {
                this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.entityQuestionIdBS && x.Id !==
                    24 && x.Id !== 25 && x.Id !== this.periodMonthId && x.Id !== this.periodYearId && x.Id !== 21 && x.Id !== 22 && x.Id !== 32 && x.Id !== 31 && x.Id !== 33);
                if (this.accountingCalendarId !== 1 && this.accountingCalendarId !== 2) {
                    nonrangeAmountQuestion = JSON.parse(JSON.stringify(this.parentQuestion.filter(e => e.Id ===
                        this.endDateId))); // New
                } else {
                    nonrangeAmountQuestion = JSON.parse(JSON.stringify(this.parentQuestion.filter(e => e.Id === this.periodMonthId || e.Id ===
                        this.periodYearId))); // New
                }
                if (nonrangeAmountQuestion.length > 0) {
                    this.currentSourceFileTab.Questions =
                        this.currentSourceFileTab.Questions.filter(f => f.QuestionParent !== 7);
                    let insertAt = this.currentSourceFileTab.Questions.findIndex(x => x.Id === questionId);

                    nonrangeAmountQuestion.forEach(x => {

                        if (x.Id === this.periodMonthId) {
                            if (this.currentSourceFileTab.PeriodId === this.sheetCoverageId) {
                                insertAt++;
                                this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                            }
                        } else if (x.Id === this.periodYearId) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId) {
                                insertAt++;
                                this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                            }
                        } else if (x.Id === 33) {
                            if (this.currentSourceFileTab.PeriodIdYear === this.sheetCoverageId) {
                                insertAt++;
                                this.currentSourceFileTab.Questions.splice(insertAt, 0, x);
                            }
                        }
                    });
                }
            }
        }

    }

    getQuestionBasedOnSelectMapping(mappingtype) {
        this.finalamountQs = [];
        const isPLAmountQuestion = this.currentSourceFileTab.Questions.filter(x => x.Id === this.plAccountId);
        const isBSAmountQuestion = this.currentSourceFileTab.Questions.filter(x => x.Id === this.bsAccountId);

        if (mappingtype === 'pl') {
            this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.bsAccountId);
            if (isPLAmountQuestion.length === 0) {
                this.finalamountQs = this.childQsById
                    .filter(x => x.Id === this.plAccountId);
            }

        } else if (mappingtype === 'bs') {
            this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.plAccountId);
            if (isBSAmountQuestion.length === 0) {
                this.finalamountQs = this.childQsById
                    .filter(x => x.Id === this.bsAccountId);
            }
        } else if (mappingtype === 'pl,bs') {


            if (isPLAmountQuestion.length > 0 && isBSAmountQuestion.length === 0) {
                this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.bsAccountId);
                this.finalamountQs = this.childQsById.filter(x => x.Id === this.bsAccountId);
            } else if (isBSAmountQuestion.length > 0 && isPLAmountQuestion.length === 0) {
                this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.plAccountId);
                this.finalamountQs = this.childQsById.filter(x => x.Id === this.plAccountId);
            }
        } else {
            this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.plAccountId && x.Id !==
                this.bsAccountId);
        }
        // if (this.currentSourceFileTab.Questions.filter(x => x.Id == this.plbsAmountId && x.QuestionParentAnswer == 2).length == 0) {
        //  this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.plOrbsAmountId);
        // }
        // this.currentSourceFileTab.Questions = this.currentSourceFileTab.Questions.filter(x => x.Id !== this.plbsAmountId);

        this.finalamountQs.forEach(x => {
            x.AnswerFreeText = null;
            this.currentSourceFileTab.Questions.push(x);
        });

        this.currentSourceFileTab.Questions.map((resp) => {
            this.finalengagementQs = [];
            this.finalengagementQs = this.engagementQs.filter(w => w.TypeID === resp.QuestionType);

            resp.QuestionOptions = this.finalengagementQs;
        });
        this.currentSourceFileTab.Questions.sort(function (a, b) {
            return a.Sequence - b.Sequence;
        });
    }

    getTabheaderStyleClass(sourceFileTab) {
        let tabHeaderStyleClass = '';
        if (sourceFileTab.IsProcessed) {
            tabHeaderStyleClass = 'highlight';
        } else if (sourceFileTab.FirstTabOftheGroup && this.applicableSourceFileTabs.filter(x => x.GroupName ===
            sourceFileTab.GroupName).length > 1) {
            tabHeaderStyleClass = sourceFileTab.GroupName + ' first-tab';
        } else {
            tabHeaderStyleClass = sourceFileTab.GroupName;
        }
        return tabHeaderStyleClass;
    }

    closeEventpreview($event) {
        this.confirmdisplay = $event;
    }
}
